import React from 'react';
import {View} from 'react-native';
import {useSelector} from 'react-redux';
import {get} from 'lodash';

import {LoadingBox} from '/component/base/LoadingBox';
import Text from '/component/base/Text';
import {useTranslation} from '/provider/TranslationProvider';
import {variablesFeatureFlag} from '/redux/selector/remoteConfig.selector';
import {shouldReleaseFeature} from '/util/featureRelease.util';

import {styles} from './Loading.style';

export const Loading = () => {
  const {tt} = useTranslation('reportCard.client');
  const featureFlag = useSelector(variablesFeatureFlag);
  const updatePremierPlus = shouldReleaseFeature(
    get(featureFlag, 'ff_Premier_Plus', ''),
  );
  const premierValue = updatePremierPlus ? 'Premier+' : 'Premier';

  return (
    <View style={styles.footer}>
      <View style={styles.footerRow}>
        <Text variant="button">
          {tt(
            'footer.expiringBeforeNextPremier.label',
            `Expiring Before Next ${premierValue}`,
          )}
        </Text>
        <LoadingBox style={styles.footerBoxExpiring} />
      </View>
      <View style={styles.footerRow}>
        <Text variant="button">
          {tt(
            'footer.nextScheduledPremier.label',
            `Next Scheduled ${premierValue}`,
          )}
        </Text>
        <LoadingBox style={styles.footerBoxNextScheduledPremier} />
      </View>
      <View style={styles.footerRow}>
        <Text variant="button">
          {tt('footer.totalWellnessCredits.label', 'Total Wellness Credits')}
        </Text>
        <LoadingBox style={styles.footerBoxTotalWellnessCredits} />
      </View>
    </View>
  );
};
